import {Component, OnInit}         from '@angular/core';
import {DataStore}                 from "aws-amplify";
import {User}                      from "../../../models";
import {SessionService}            from "../../services/session.service";
import {ToastServiceHelperService} from "../../services/toast-service-helper.service";
import {NavController}             from "@ionic/angular";

@Component({
    selector: 'app-add-user-info-after-first-login',
    templateUrl: './add-user-info-after-first-login.page.html',
    styleUrls: ['./add-user-info-after-first-login.page.scss'],
})
export class AddUserInfoAfterFirstLoginPage implements OnInit {
    name: any;
    lastName: any;
    private user: any;

    constructor(private route: NavController, private sessionService: SessionService, private toasterService: ToastServiceHelperService) {
    }

    async ngOnInit() {
        this.user = await DataStore.query(User, this.sessionService.user?.id);
        this.name = this.user.name;
        this.lastName = this.user.lastname;
        
    }

    async submit() {
        if (this.name == undefined || this.name == "") {
           return  await this.toasterService.error("Campo Nome è obbligatorio");
        }
        if (this.lastName == undefined || this.lastName == "") {
           return  await this.toasterService.error("Campo Cognome è obbligatorio");
        }

        await DataStore.save(User.copyOf(this.user, u => {
            u.name = this.name?.toLowerCase()?.trim();
            u.lastname = this.lastName?.toLowerCase().trim();
        }));

        await this.route.navigateRoot("/home");


    }

}
